import { render, staticRenderFns } from "./SisSearch.vue?vue&type=template&id=d668db3a&"
import script from "./SisSearch.vue?vue&type=script&lang=ts&"
export * from "./SisSearch.vue?vue&type=script&lang=ts&"
import style0 from "./SisSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports